/**
 * Series scripts
 *
 * @copyright 2018 Linguistica 360
 */

import 'slick-carousel';

import $ from 'jquery';

import { Script, injector } from '../shared/injector.js';

injector.injectClass(class extends Script {
    onLoad() {
        $('.nav-icons.series-icons').each(function () {
            const $this = $(this);
            const $slick = $this.find('div.ul');

            $slick.css({
                width: 'auto',
                visibility: 'visible',
            }).on('init', function (_, slick) {
                const sel = '.li.active';
                const $active = $slick.find(sel).parents('.slick-slide');
                if ($active.length) {
                    const count = $slick.find('.slick-slide').length;
                    let index = $active.data('slick-index');

                    const $line = $slick.find('.slick-list');
                    const show = Math.floor($line.width() / $active.width()) - 1;

                    const back = count - index;
                    if (back < show) index = Math.max(0, index - (show - back));

                    slick.goTo(index, true);
                }
            });

            $slick.slick({
                arrows: false,
                infinite: false,
                variableWidth: true,
                slidesToScroll: 1,
                swipeToSlide: true,
            });

            const $prev = $this.prev().find('.navicons-arrow.left');
            const $next = $this.prev().find('.navicons-arrow.right');

            $prev.on('click', () => {
                let index = 0, show = 10;
                const $current = $slick.find('.slick-slide.slick-current');
                if ($current.length) {
                    index = $current.data('slick-index');

                    const $line = $slick.find('.slick-list');
                    show = Math.floor($line.width() / $current.width());
                }

                const prev = Math.max(Math.floor(index - show) / 2, 0);
                $slick.slick('goTo', prev);
            });

            $next.on('click', () => {
                const count = $slick.find('.slick-slide').length;

                let index = 0, show = 10;
                const $current = $slick.find('.slick-slide.slick-current');
                if ($current.length) {
                    index = $current.data('slick-index');

                    const $line = $slick.find('.slick-list');
                    show = Math.floor($line.width() / $current.width());
                }

                if (index + show > count) return;
                const next = Math.floor(index + show / 2);
                $slick.slick('goTo', next);
            });
        });
    }
});
